<ngx-loading-bar [height]="'5px'" [color]="'#21af85'" [includeSpinner]="false"></ngx-loading-bar>
<router-outlet></router-outlet>